(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends HTMLElement {
      constructor() {
          super()
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'title-list': Array.from(this.children),
          'content-list': Array.from(document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || [])
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        this.initTabs()
        this.addEventListener('click', (e) => {
          let item = e.target.closest('.tab-title');
          if (item) {
            let i = this.sectionsEl['title-list'].indexOf(item);
            this.itemClick(item, i);
          }
        });
      }

      initTabs() {
        this.sectionsEl['title-list']?.forEach((el, i) => {
          if (!el.classList.contains('tab-title')) {
            el.classList.add('tab-title');
          }
          
          if (i == 0) {
            el.classList.add('is-active');
          }
        });
        this.updateStyle(this.sectionsEl['title-list'][0]);

        this.sectionsEl['content-list'].forEach((el, i) => {
          if (!el.classList.contains('tab-content')) {
            el.classList.add('tab-content');
          }

          if (i == 0)  el.classList.add('is-active');
        });
      }

      itemClick(el, i) {
        // 如果已经激活则直接返回
        if (el.classList.contains('is-active')) return;

        // el.scrollIntoView({ behavior: 'smooth', inline: 'center', container: 'nearest' });
        this.toggleClass(el, i)
      }

      toggleClass(el, i) {
        // 处理标题激活状态
        this.sectionsEl['title-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        el.classList.add('is-active');
        this.updateStyle(el);

        // 处理内容激活状态
        this.sectionsEl['content-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        if (this.sectionsEl['content-list'][i])
          this.sectionsEl['content-list'][i].classList.add('is-active');
      }

      updateStyle(el = null) {
        let itemEl = el || this.querySelector('.is-active');

        if (!itemEl) return;
        let left = itemEl.offsetLeft;
        let width = itemEl.offsetWidth;
        this.style.setProperty('--scroll-item-left', `${left}px`);
        this.style.setProperty('--scroll-item-width', `${width}px`);
      }
  }
  if (!window.customElements.get('yg-tabs-title')) {
      window.customElements.define('yg-tabs-title', YGTabsTitle)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {

    constructor() {

      super();

      this.playVideoClick = this.playVideo.bind(this);

      this.autoplay = this.getAttribute('data-autoplay');

      this.popup = this.getAttribute('data-popup');

      this.type = this.getAttribute('data-type');

      this.isMuted = true;

    }



    get videoContainer() {

      return this.querySelector('.yg-video-iframe-container');

    }



    get image() {

      return this.querySelector('.yg-video-placeholder');

    }



    get template() {

      return this.querySelector('template');

    }



    get playVideoButton() {

      return this.querySelector('.yg-play-video');

    }



    connectedCallback() {

      this.playVideoButton?.addEventListener('click', this.playVideoClick);

      if (this.autoplay == 'true' && this.popup == 'false') {

        this.getLazyLoader().observe(this);

      }

    }



    applyMuteStateToVideos() {

      if (this.type !== 'video' || !this.videoContainer) return;

      const videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

      if (!videos.length) return;

      videos.forEach(video => {

        video.muted = this.isMuted;

      });

    }



    ensureInlineAndMuted(videoEl) {

      // Mobile autoplay policy: must be muted and inline (especially iOS Safari).

      if (!videoEl) return;

      videoEl.muted = this.isMuted;

      videoEl.setAttribute('muted', '');

      videoEl.setAttribute('playsinline', '');

      videoEl.setAttribute('webkit-playsinline', '');

    }



    playNativeVideos() {

      if (this.type !== 'video' || !this.videoContainer) return;

      const videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

      if (!videos.length) return;



      this.videoContainer.classList.remove('hide');

      const isMobile = window.matchMedia('(max-width: 699px)').matches;



      videos.forEach((video) => {

        const desktopOnly = video.classList.contains('hide-mobile');

        const mobileOnly = video.classList.contains('hide-pc');

        const shouldPlay = isMobile ? !desktopOnly : !mobileOnly;



        if (!shouldPlay) {

          video.pause();

          video.preload = 'none';

          return;

        }



        this.ensureInlineAndMuted(video);

        const p = video.play();

        // Avoid unhandled promise rejection on mobile browsers when autoplay is blocked.

        if (p && typeof p.catch === 'function') p.catch(() => {});

      });

    }



    playVideo() {

      if (this.popup == 'true') {

        this.dispatchEvent(

          new CustomEvent('YG:openPopup', {

            bubbles: true,

            detail: {

              popupTemplate: this.template,

            },

          })

        );



        return;

      }



      this.image?.classList.add('hide');

      this.playVideoButton?.classList.add('hide');



      // If content is already in DOM, play immediately.

      if (this.type == 'video' && this.videoContainer) {

        this.playNativeVideos();

        return;

      }



      // Otherwise, inject template content then try to play (mobile autoplay might require explicit play()).

      this.appendChild(this.template?.content.cloneNode(true));

      this.applyMuteStateToVideos();

      this.playNativeVideos();

    }



    toggleMute(buttonEl) {

      this.isMuted = !this.isMuted;

      this.applyMuteStateToVideos();

      this.updateMuteButtonState(buttonEl);

    }



    updateMuteButtonState(buttonEl) {

      if (!buttonEl) return;



      if (this.isMuted) {

        buttonEl.classList.add('is-muted');

        buttonEl.setAttribute('aria-pressed', 'true');

      } else {

        buttonEl.classList.remove('is-muted');

        buttonEl.setAttribute('aria-pressed', 'false');

      }

    }



    pauseVideo() {

      this.image?.classList.remove('hide');

      this.playVideoButton?.classList.remove('hide');

      if (this.type == 'video' && this.videoContainer) {

        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.add('hide');



        videos.forEach(video => {

          video.pause();

          // video.currentTime = 0.001;

        });

      } else {

        this.videoContainer?.remove();

      }

    }

  }

  document.addEventListener('DOMContentLoaded', () => {

    if (!window.customElements.get('yg-video')) {

      window.customElements.define('yg-video', YGVideo);

    }

  });
  } catch(e) { console.error(e); }
})();

})();
